import { ref, Ref } from 'vue'
import { defineStore } from 'pinia'
import { EscortDress, EscortVehicle } from '../types/enums'
import api from '../services/api'
import { Therapist } from '../pages/therapists/types'
import { Guide } from '../pages/guides/types'
import { Teacher } from '../pages/teachers/types'
export const usePublicStore = defineStore('publicStore', () => {
    const headerConfig = ref({
        title: '',
        useBackIcon: false,
    })
    const setHeaderConfig = (config: { title: string; useBackIcon: boolean }) => {
        headerConfig.value = config
    }
    const escortPlans: Ref<Public.EscortPlan[]> = ref([
        {
            id: 1,
            name: '東方小巴黎',
            serviceContent: `您可以挑選您喜愛的奧黛美女導遊陪您遊玩胡志明市中心的網美景點，包括：濱城市場、統一宮、Landmark81、胡志明市美術館、戰爭博物館、粉紅教堂、聖母教堂、咖啡公寓、胡志明書街、西貢郵局等等景點。本行程可選配「防曬遮雨的嘟嘟車」，乘車接送地點限定在胡志明市第1郡範圍內。`,
            serviceTime: '本項行程至少3小時，服務可預訂時間從上午9:00開始，每日最後陪同導遊開始時間為下午3:00',
            serviceNote: [
                '本服務需提前12小時預訂。',
                '在此行程中您可以選擇3個預設遊玩的景點，每個景點建議預留1小時-1個半小時的遊玩時間。',
                '您所選擇的景點可能因場館維護或國定假日而未開放，您可以與導遊討論變更遊玩地點。',
                '遊玩交通工具可加價100萬升級嘟嘟車（防曬擋雨），如行程時間在下午3點後，則需加價200萬升級嘟嘟車。',
                '服務超時費用：50萬/時，未滿一小時以一小時計。',
            ],
            description: '用性價比最高的方式暢完西貢吧！ 讓奧黛導遊帶您遊歷這座城市必玩的網美打卡景點！',
            totalBuyers: 689,
            basePrice: 1500000,
            bookingDeposit: 500000,
            pricePerHour: 500000,
            extraAmount: 0,
            attractionIds: [1, 2, 3, 5, 6, 7, 8, 10, 12, 13, 14, 15, 16],
            allowDress: [EscortDress.NORMAL, EscortDress.AO_DAI],
            allowVehicles: [EscortVehicle.SCOOTER, EscortVehicle.DO_DO_CAR, EscortVehicle.TAXI],
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/plan/tourCardPhoto01.png',
            minServiceHours: 3,
            hoursBeforeBooking: 12,
            serviceTimeType: 'normal',
            fixedServiceStartTime: '',
            firstServiceStartTime: '09:00', // 'HH:mm'
            lastServiceStartTime: '15:00', // 'HH:mm'
        },
        {
            id: 2,
            name: '華燈夜生活',
            serviceContent: `您可挑選專屬導遊陪您前往西貢知名胡氏紀夜市、海鮮一條街、范老五街、咖啡公寓、濱城市場等等夜遊景點，本項行程包含與導遊共享餐點1小時~2小時，夜間行程恕不提供提供奧黛穿著服務。`,
            serviceTime: '本項行程至少3小時，服務提供時間從下午4:00開始，每日最後陪同導遊開始時間為晚上22:00。',
            serviceNote: [
                '本服務需提前12小時預訂。',
                '在此行程中您可以選擇1-2個預設遊玩的景點，每個景點建議預留1小時-1個半小時的遊玩時間。',
                '遊玩交通工具可加價200萬升級更嘟嘟車（防曬擋雨）。',
                '服務超時費用：50萬/時，未滿一小時以一小時計。',
                '服務時間：至少3小時',
            ],
            description: '胡志明市最讓人眷戀的時刻正是華燈初上之時，讓您的奧黛導遊一起在這座城市的探秘吧！',
            totalBuyers: 527,
            basePrice: 1500000,
            bookingDeposit: 500000,
            pricePerHour: 500000,
            extraAmount: 0,
            attractionIds: [1, 2, 4, 6, 8, 9, 10, 11, 12, 13, 14],
            allowDress: [EscortDress.NORMAL],
            allowVehicles: [EscortVehicle.SCOOTER, EscortVehicle.DO_DO_CAR, EscortVehicle.TAXI],
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/plan/tourCardPhoto02.png',
            minServiceHours: 3,
            hoursBeforeBooking: 12,
            serviceTimeType: 'normal',
            fixedServiceStartTime: '',
            firstServiceStartTime: '16:00', // 'HH:mm'
            lastServiceStartTime: '22:00', // 'HH:mm'
        },
        {
            id: 3,
            name: '西貢河船宴',
            serviceContent: `本項行程共4小時（含前往碼頭交通時間約1小時，唯交通時間可能因您的接送地點而異），與奧黛導遊歷西貢河，並且在船上共進晚餐，一同享受最道地的越南傳統美食，在西貢夜幕的美景下，啟動您在西貢夜生活的步調。`,
            serviceTime:
                '本項行程每日提供一班次服務，服務時間固定為下午5點半開始提供服務，由導遊陪您可搭乘機車或Grab前往至4郡碼頭乘船乘坐，與您一同遊歷西貢河，享受遊輪上的越南傳統美食，每日晚上6點半上船，進行3小時的導覽及享用晚餐，本行程預估在晚上9點半下船。',
            serviceNote: [
                '本服務需提前24小時預訂。',
                '本方案費用包含船票、餐點，每人總費用350萬。',
                '如您不想搭乘摩托車，您可以在下訂頁面選擇要搭乘Grab，並標示搭乘飯店位置，由導遊前往您的住所與您開始行程，唯本行程來回需由您車資自理。',
                '如遇天候不佳情形，則由導遊可改採以陪同乘坐Grab至乘船碼頭。',
                '導遊服務超時費用：50萬/時，未滿一小時以一小時計算。',
                '服務時間至少4小時',
            ],
            description: '離開市中心喧囂的街道，和奧黛導遊搭上郵輪在五光十色的西貢河欣賞最美麗的夜景及美食！',
            price: 'VND 3.500K 起',
            totalBuyers: 262,
            basePrice: 3500000,
            bookingDeposit: 2000000,
            pricePerHour: 500000,
            extraAmount: 1500000,
            attractionIds: [],
            allowDress: [EscortDress.NORMAL, EscortDress.AO_DAI],
            allowVehicles: [EscortVehicle.SCOOTER, EscortVehicle.TAXI],
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/plan/tourCardPhoto03.png',
            minServiceHours: 4,
            hoursBeforeBooking: 24,
            serviceTimeType: 'fixed',
            fixedServiceStartTime: '17:30',
            firstServiceStartTime: '', // 'HH:mm'
            lastServiceStartTime: '', // 'HH:mm'
        },
        {
            id: 4,
            name: '韓式桑拿趣',
            serviceContent: `由您挑選的導遊騎車到貴賓指定接送地點陪同您前往桑拿場館，您可以指定搭乘機車或Grab，本方案交通時間往返約1小時（交通時間可能因您的接送地點而異），韓式汗蒸樂園趣味互動，一同與導遊體驗傳統韓式汗蒸幕，並於spa後享用韓式料理1餐。`,
            serviceTime: '本項行程至少4小時，服務可預訂時間從上午9:00開始，每日最後陪同導遊開始時間為晚間7:00。',
            serviceNote: [
                '本服務需提前12小時預訂。',
                '本方案費用包含門票、餐點，每人總費用350萬。',
                '如您不想搭乘摩托車，您可以在下訂頁面選擇要搭乘Grab，並標示搭乘飯店位置，由導遊前往您的住所與您開始行程，唯本行程來回需由您車資自理。',
                '如遇天候不佳情形，可改採以陪同乘坐Grab至場館地點。',
                '導遊服務超時費用：50萬/時，未滿一小時以一小時計算。',
                '服務時間至少4小時',
            ],
            description:
                '不用去韓國也能體驗最道地的韓式桑拿服務，讓奧黛導遊陪您享受香汗淋漓的滋味，為您釋放所有旅途積累的疲憊！',
            price: 'VND 3.500K 起',
            totalBuyers: 381,
            basePrice: 3500000,
            bookingDeposit: 500000,
            pricePerHour: 500000,
            extraAmount: 1500000,
            attractionIds: [],
            allowDress: [EscortDress.NORMAL],
            allowVehicles: [EscortVehicle.SCOOTER, EscortVehicle.TAXI],
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/plan/tourCardPhoto04.png',
            minServiceHours: 4,
            hoursBeforeBooking: 12,
            serviceTimeType: 'normal',
            fixedServiceStartTime: '17:30',
            firstServiceStartTime: '09:00', // 'HH:mm'
            lastServiceStartTime: '19:00', // 'HH:mm'
        },
    ])
    const guides = ref<Guide[]>([])
    // const escorts = ref([
    //     {
    //         id: 1,
    //         name: '大S',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide01.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%A4%A7S-A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%A4%A7S-B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%A4%A7S-C.webp',
    //         ],
    //         height: 165,
    //         weight: 48,
    //         age: 22,
    //         language: ['中文', '英文'],
    //         feature: ['可牽手', '溫柔貼心', '可１對１伴遊'],
    //         interest: ['學習語言', '烹飪', '喜歡任何能令我發笑的人事物', '喜歡貓咪和狗'],
    //         checked: false,
    //     },
    //     {
    //         id: 2,
    //         name: '虹兒',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide02.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%99%B9%E5%85%92A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%99%B9%E5%85%92B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%99%B9%E5%85%92C.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%99%B9%E5%85%92D.webp',
    //         ],
    //         height: 165,
    //         weight: 48,
    //         age: 24,
    //         language: ['中文略懂', '英文'],
    //         feature: ['可牽手', '熱情大方'],
    //         interest: ['學習語言', '熱愛旅遊', '烹飪', '交友'],
    //         checked: false,
    //     },
    //     {
    //         id: 3,
    //         name: '薇薇',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide03.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%96%87%E8%96%87A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%96%87%E8%96%87B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%96%87%E8%96%87C.webp',
    //         ],
    //         height: 157,
    //         weight: 44,
    //         age: 21,
    //         language: ['中文略懂'],
    //         feature: ['可牽手', '平面麻豆'],
    //         interest: ['認識外國朋友', '唱歌', '享受美食', '逛街購物', '攝影'],
    //         checked: false,
    //     },
    //     {
    //         id: 4,
    //         name: '蓉蓉',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide04.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%93%89%E8%93%89A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%93%89%E8%93%89B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%93%89%E8%93%89C.webp',
    //         ],
    //         height: 161,
    //         weight: 50,
    //         age: 19,
    //         language: ['英文'],
    //         feature: ['越南名校大學生'],
    //         interest: ['戶外活動', '語言學習', '健身', '貓控', '單身'],
    //         checked: false,
    //     },
    //     {
    //         id: 5,
    //         name: '清兒',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide05.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E6%B8%85%E5%85%92A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E6%B8%85%E5%85%92C.webp',
    //         ],
    //         height: 157,
    //         weight: 49,
    //         age: 24,
    //         language: ['中文略懂', '英文'],
    //         feature: ['可牽手'],
    //         interest: ['認識不同的外國朋友', '和好友上KTV', '享受美食', 'SPA'],
    //         checked: false,
    //     },
    //     {
    //         id: 6,
    //         name: '崔崔',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide06.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B4%94%E5%B4%94A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B4%94%E5%B4%94B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B4%94%E5%B4%94C.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B4%94%E5%B4%94E.webp',
    //         ],
    //         height: 162,
    //         weight: 48,
    //         age: 25,
    //         language: ['中文略懂', '英文略懂'],
    //         feature: ['法越混血', '熱情活潑'],
    //         interest: ['戶外活動', '異國美食', '健身', '機車旅行', '甜點製作'],
    //         checked: false,
    //     },
    //     {
    //         id: 7,
    //         name: '草兒',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide07.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%8D%89%E5%85%92A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%8D%89%E5%85%92B.webp',
    //         ],
    //         height: 156,
    //         weight: 48,
    //         age: 25,
    //         language: ['中文略懂', '英文略懂'],
    //         feature: ['可牽手'],
    //         interest: ['學習語言', '熱愛旅遊', '吃貨', '交友'],
    //         checked: false,
    //     },
    //     {
    //         id: 8,
    //         name: 'Somi',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide08.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/SOMI-A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/SOMI-B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/SOMI-C.webp',
    //         ],
    //         height: 168,
    //         weight: 47,
    //         age: 22,
    //         language: ['中文(學習中)', '英文溝通佳'],
    //         feature: ['熱情', '友善', '自由', '可牽手', '可1對1伴遊'],
    //         interest: ['旅遊', '學習外語', '享受美食', '閱讀', '購物', '電影', '有趣的事物', '貓'],
    //         checked: false,
    //     },
    //     {
    //         id: 9,
    //         name: '玉兒',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide09.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E7%8E%89%E5%85%92A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E7%8E%89%E5%85%92B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E7%8E%89%E5%85%92C.webp',
    //         ],
    //         height: 154,
    //         weight: 46,
    //         age: 20,
    //         language: ['英文'],
    //         feature: ['可牽手', '體貼可人'],
    //         interest: ['學習語言', '瑜珈健身', '吃貨', '交友', '藝術美甲', '單身'],
    //         checked: false,
    //     },
    //     {
    //         id: 10,
    //         name: '小夏',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide10.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E5%A4%8FA.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E5%A4%8FB.webp',
    //         ],
    //         height: 158,
    //         weight: 47,
    //         age: 20,
    //         language: ['英文'],
    //         feature: ['熱情大方'],
    //         interest: ['學習語言', '熱愛旅遊', '吃貨', '認識外國朋友', '喜歡有寵物的陪伴'],
    //         checked: false,
    //     },
    //     {
    //         id: 11,
    //         name: '范玄',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide11.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%8C%83%E7%8E%84A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%8C%83%E7%8E%84B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%8C%83%E7%8E%84C.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%8C%83%E7%8E%84D.webp',
    //         ],
    //         height: 165,
    //         weight: 50,
    //         age: 25,
    //         language: ['英文', '中文'],
    //         feature: ['友善', '開朗', '熱情'],
    //         interest: ['唱歌', '跳舞', '旅遊', '看書'],
    //         checked: false,
    //     },
    //     {
    //         id: 12,
    //         name: '奶糖',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide12.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%A5%B6%E7%B3%96A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%A5%B6%E7%B3%96B.webp',
    //         ],
    //         height: 153,
    //         weight: 45,
    //         age: 18,
    //         language: ['英文略懂', '中文略懂'],
    //         feature: ['可愛動人', '可牽手'],
    //         interest: ['學習語言', '喜歡熱鬧的地方', '認識外國朋友', '熱愛街頭小吃', '貓控'],
    //         checked: false,
    //     },
    //     {
    //         id: 13,
    //         name: '小春',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide13.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E6%98%A5A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E6%98%A5B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E6%98%A5C.webp',
    //         ],
    //         height: 155,
    //         weight: 46,
    //         age: 22,
    //         language: ['英文', '中文略懂'],
    //         feature: ['可愛動人', '可牽手'],
    //         interest: ['露營', '戶外活動', '游泳', '認識外國朋友', '唱歌'],
    //         checked: false,
    //     },
    //     {
    //         id: 14,
    //         name: '小月',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide14.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E6%9C%88A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E6%9C%88B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E6%9C%88C.webp',
    //         ],
    //         height: 154,
    //         weight: 48,
    //         age: 25,
    //         language: ['英文略懂', '中文略懂'],
    //         feature: ['熱情大方'],
    //         interest: ['攝影', '喝咖啡', '安靜的地方', '閱讀', '認識外國朋友', '和好友聚餐'],
    //         checked: false,
    //     },
    //     {
    //         id: 15,
    //         name: '小貝',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide15.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E8%B2%9DA.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E8%B2%9DB.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E8%B2%9DC.webp',
    //         ],
    //         height: 155,
    //         weight: 46,
    //         age: 19,
    //         language: ['英文略懂', '中文略懂'],
    //         feature: ['活潑熱情'],
    //         interest: ['水上活動', '喜愛大自然', '露營', '貓控', '單身', '聽演唱會'],
    //         checked: false,
    //     },
    //     {
    //         id: 16,
    //         name: '譚瓊',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide16.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E8%AD%9A%E7%93%8AA.webp',
    //         ],
    //         height: 170,
    //         weight: 49,
    //         age: 26,
    //         language: ['英文略懂', '中文略懂'],
    //         feature: ['熱情', '友善', '可牽手', '可1對1伴遊'],
    //         interest: ['旅行'],
    //         checked: false,
    //     },
    //     {
    //         id: 17,
    //         name: '小臉',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide17.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%B0%8F%E8%87%89A.webp',
    //         ],
    //         height: 173,
    //         weight: 56,
    //         age: 26,
    //         language: ['英文'],
    //         feature: ['熱情', '友善', '可牽手', '可1對1伴遊'],
    //         interest: ['看電影', '旅行'],
    //         checked: false,
    //     },
    //     {
    //         id: 18,
    //         name: '玲玲',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide18.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E7%8E%B2%E7%8E%B2.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E7%8E%B2%E7%8E%B2A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E7%8E%B2%E7%8E%B2B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E7%8E%B2%E7%8E%B2C.webp',
    //         ],
    //         height: 157,
    //         weight: 48,
    //         age: 23,
    //         language: ['英文'],
    //         feature: ['熱情', '友善', '可牽手', '可1對1伴遊'],
    //         interest: ['學習語言', '喜歡熱鬧的地方', '認識外國朋友', '熱愛街頭小吃'],
    //         checked: false,
    //     },
    //     {
    //         id: 19,
    //         name: '寶意',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide19.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%AF%B6%E6%84%8FA.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%AF%B6%E6%84%8FB.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%AF%B6%E6%84%8FC.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/%E5%AF%B6%E6%84%8FD.webp',
    //         ],
    //         height: 168,
    //         weight: 47,
    //         age: 23,
    //         language: ['中文', '廣東粵語', '潮州語'],
    //         feature: ['開朗', '熱情', '幽默', '可牽手', '可1對1伴遊'],
    //         interest: ['購物', '旅遊'],
    //         checked: false,
    //     },
    //     {
    //         id: 20,
    //         name: 'Susan',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide20.png',
    //         images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/Susan-B.webp'],
    //         height: 175,
    //         weight: 59,
    //         age: 23,
    //         language: ['英文'],
    //         feature: ['熱情', '可牽手', '可1對1伴遊'],
    //         interest: ['看新聞', '美容', '聽音樂'],
    //         checked: false,
    //     },
    //     {
    //         id: 21,
    //         name: 'Sora',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/tourGuide21.png',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/Sora-A.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/Sora-B.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/Sora-C.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/Sora-D.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/Sora-E.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/Sora-F.webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/escort/Sora-G.webp',
    //         ],
    //         height: 175,
    //         weight: 59,
    //         age: 21,
    //         language: ['英文'],
    //         feature: ['熱情', '可牽手', '可1對1伴遊'],
    //         interest: ['攝影', '旅遊'],
    //         checked: false,
    //     },
    // ])
    const attractions = ref([
        {
            id: 1,
            name: '胡志明廣場',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction01.png',
            images: [
                'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions01.webp',
                'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions01_2.webp',
            ],
            description:
                '胡志明廣場是 19 世紀和 20 世紀南越歷史的縮影，透過廣場四周的法國建築探索越南的殖民歷史。在胡志明廣場的最北側是人民委員會大廳，這棟仿造巴黎市政廳的優雅建築，是由法國人仿於 1908 年建造完成，座落在廣場北側整整一個街區，正對著人民委員會大廳的便是阮惠步行街及胡志明廣場，入夜後將成為西貢市民最佳約會地點。',
            stayTime: '60分鐘 ~ 90分鐘',
            checked: false,
        },
        {
            id: 2,
            name: '咖啡公寓',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction02.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions02.webp'],
            description:
                '咖啡公寓大樓位於阮惠步行街 42 號，是現代與舊世界魅力的獨特融合。這棟九層公寓大樓最初建於 20 世紀 60 年代中期，多年來經歷了各種改造。如今，它擁有一系列充滿活力的獨立咖啡館、工作室、精品時裝店和共同工作空間。它坐落在阮惠步行街上，已成為尋求熱鬧氛圍和創意體驗的遊客的熱門目的地，也是時下年輕人最喜歡前往探索的文青打卡地點之一。',
            stayTime: '60分鐘 ~ 90分鐘',
            checked: false,
        },
        {
            id: 3,
            name: '戰爭博物館',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction03.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions03.webp'],
            description:
                '戰爭遺址博物館一直是胡志明市乃至越南最受遊客歡迎的景點之一，博物館內展示了大量的戰爭遺物、照片和文物，讓遊客可以深入了解當時的戰爭情況。此外，博物館還提供導覽服務，讓遊客更好地理解展品的背後故事。如果您對歷史感興趣，那麼這個博物館絕對是您不容錯過的地方。 來到這裡，您將能夠更好地理解越南的歷史和文化。',
            stayTime: '60分鐘 ~ 90分鐘',
            checked: false,
        },
        {
            id: 4,
            name: '胡氏紀夜市',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction04.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions04.webp'],
            description:
                '位於第10郡的胡氏紀夜市是西貢受到年輕人歡迎的夜市之一，胡氏紀夜市也是全西貢最大的花卉集散市場，在這邊除了可以欣賞到各式新鮮的花卉之外，你還能在這個熱鬧的夜市裡，挖掘到最道地的越南街頭美食，在這熱鬧、充滿活力的市集上品嚐美味佳餚，補充您在一整天的旅程中的能量。',
            stayTime: '90分鐘 ~ 120分鐘',
            checked: false,
        },
        {
            id: 5,
            name: '獨立宮',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction05.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions05.webp'],
            description:
                '獨立宮又稱統一宮、總督府或總督宮。這座歷史悠久的建築曾經是越南共和國總統的官邸。這個地方有著獨特的建築風格，被認為是亞洲最美麗的別墅。獨立宮由 3 個主層組成，包括一個基礎層、一個夾層、兩個地下室和一個可供直升機降落的露台。裡面有100多個房間，根據不同的用途裝飾成不同的風格。包括內閣會議室、特等艙、文件展示室、宴會廳、畫廊等房間。獨立宮裡頭充滿著著越南戰爭的歷史痕跡，是來胡志明市觀光不可錯過的景點之一。',
            stayTime: '90分鐘',
            checked: false,
        },
        {
            id: 6,
            name: 'Landmark 81',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction06.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions06.webp'],
            description:
                'Landmark 81高達 461.2 公尺，至 2018 年竣工時是越南最高的建築，也是當時東南亞最高的建築，它聳立於平盛區的高級住宅社區內，採用受竹子外型啟發的優雅而現代的設計，是胡志明市的經濟繁榮的象徵。來到胡志明市旅遊，值得您來一趟 Landmark 81從Skyview 戶外觀景台鳥瞰胡志明市的美麗的繁華市景。',
            stayTime: '60分鐘 ~ 90分鐘',
            checked: false,
        }, // 產生幾個同格式的物件
        {
            id: 7,
            name: '西貢郵局',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction07.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions07.webp'],
            description:
                '西貢中心郵局是法國人於1886年至1891年建造。這座擁有百年歷史的郵局很榮幸被美國建築雜誌《建築文摘》評選為全球11個最美郵局第二名，更是古典西貢的代表。西貢中心郵局也是許多越南年輕人最喜歡的「拍照打卡」的網美景點之一，主體大樓的中間有一個大鐘，下面是工程的建造和竣工日期（1886年-1891年）。周圍飾有精美的白色浮雕，中間是希臘神話中的使者神赫爾墨斯。',
            stayTime: '30分鐘',
            checked: false,
        },
        {
            id: 8,
            name: '書街',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction08.png',
            images: [
                'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions08.webp',
                'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions08_2.webp',
            ],
            description:
                '書街是胡志明市各個街道中最為寧靜的地方，在這邊您可以找到屬於您自己的角落，，它位於西貢中央郵局附近，在這條小街道上有著獨特的獨立書店和書香氣息的咖啡館，入夜後的書街也會不定期有各式各樣的文創攤位在這裡為旅人服務，感受越南人的文青氛圍。',
            stayTime: '30分鐘',
            checked: false,
        },
        {
            id: 9,
            name: '裴援步行街',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction09.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions09.webp'],
            description:
                '在閃爍的霓虹燈和酒吧傳來的喧鬧聲下，「不眠」的裴援步行街顯得浮華，是西貢年輕人繁華生活中不可缺少的一部分。裴援步行街 (Bui Vien Street) 也被譽為西貢的派對和歡樂天堂，這裡有西貢最著名的酒吧和酒館，這些商店都彼此靠近，喜愛夜生活的你，在這裡有各式各樣的選擇，讓您在旅途中可以盡情放鬆身心，體驗西貢最喧囂的夜生活！',
            stayTime: '30分鐘',
            checked: false,
        },
        {
            id: 10,
            name: '金融塔',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction10.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions10.webp'],
            description:
                '金融塔是越南的高空觀景台之一，它的外型如同一張卷合的荷葉，由地上向天空亭亭舒展，與緊湊而密集的城市框架相比，金融塔的外觀相當格外引人註目。讓我們一起登上 Bitexco 金融塔 49 層的西貢觀景台，從這座城市最具標誌性的建築之一，360度欣賞胡志明市的全景。',
            stayTime: '60分鐘 ~ 90分鐘',
            checked: false,
        },
        {
            id: 11,
            name: '永慶美食街',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction11.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions11.webp'],
            description:
                '想吃得像西貢在地人一樣嗎？那你一定不能錯過位於4郡的永慶 (Vĩnh Khánh)美食街，內行的遊客又稱又稱海鮮一條街，永慶美食街 是西貢極為著名的美食街之一。這家店位於馬路兩旁，總是很熱鬧，街道上各式餐館菜餚種類繁多，吸引了許多在地人和慕名而來的遊客，尤其是週末晚上的饕客人潮絡繹不絕。',
            stayTime: '60分鐘 ~ 120分鐘',
            checked: false,
        },
        {
            id: 12,
            name: '濱城市場',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction12.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions12.webp'],
            description:
                '濱城市場位於西貢的特別地段，是該市最黃金的中心區。濱城市場是西貢及週邊地區人民進行貿易和交換貨物的場所，市場有東、西、南、北4個門。每家商店都有許多受歡迎的商品，因此遊客可以參觀或當場享用美食，您可以在市場裡輕鬆找到從時裝、工藝品到家電、電子產品、特產和紀念品的一切商品。',
            stayTime: '30分鐘 ~ 90分鐘',
            checked: false,
        },
        {
            id: 13,
            name: '耶穌聖心堂',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction13.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions13.webp'],
            description:
                '胡志明市新定教堂，因為其粉紅浪漫的外觀，被大眾稱為「粉紅教堂」，是胡志明第二大天主教堂。粉紅教堂採用羅馬式設計、巴洛克式裝飾，精緻的雕花窗及夢幻粉紅色外牆，是擁有少女心的各位絕對不能錯過的好拍景點！遊客太多時，建議可以到對面Cộng café的三樓，不需要人擠人就能抓到完美的取景角度，愜意喝咖啡同時，還能欣賞教堂的華麗外觀！',
            stayTime: '30分鐘',
            checked: false,
        },
        {
            id: 14,
            name: '紅教堂',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction14.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions14.webp'],
            description:
                '西貢聖母聖殿主教座堂是胡志明市中心著名的宗教建築作品，具有極其古老、莊嚴的新羅馬建築風格。這座教堂不僅是越南天主教的象徵，也是胡志明市獨特的建築作品之一，也是和平聖母雕像所在的地方，遊客經常停下來駐留拍照、觀賞鴿子，教堂周圍更是假日年輕人約會的熱門地點，一起來感受紅教堂外圍的浪漫氣氛吧。(教堂內部整修中，預計2027年對外開放)',
            stayTime: '30分鐘',
            checked: false,
        },
        {
            id: 15,
            name: '美術館',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction15.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions15.webp'],
            description:
                '胡志明市美術館外觀是一幢帶著鵝黃色的三層建築，於1934年間完工，其實是當時西貢華商的別墅、故居，後來在1987年被越南政府指定改建為藝術館。這裡也是知名的網紅景點之一，遊客僅僅是透過欣賞著建築的外觀，就能感受到當年宏偉氣派，融合法式殖民色彩、及中式建築的特色、實地感受胡志明市當地的藝術人文氣息。',
            stayTime: '30分鐘 ~ 90分鐘',
            checked: false,
        },
        {
            id: 16,
            name: '歌劇院',
            image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attraction16.png',
            images: ['https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/attraction/attractions16.webp'],
            description:
                '胡志明市大劇院屬於典型的哥德式建築風格，是專門用於舉辦藝術表演的多功能劇院，其內部裝飾和外部浮雕都是依照19世紀末法國的劇院風格修建。來到胡志明市，您可以預留一些時間欣賞有百年歷史的西貢歌劇院(Saigon Opera House)，一座代表法國殖民時代的美麗建築。',
            stayTime: '30分鐘',
            checked: false,
        },
    ])
    const therapists = ref<Therapist[]>([])
    // const therapists = ref([
    //     {
    //         id: 0,
    //         number: 0,
    //         name: '節省塔兔',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.00%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.00%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.00%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.00%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.00%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.00%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.00%20(5).webp',
    //         ],
    //         height: 156,
    //         weight: 45,
    //         birthYear: 1997,
    //         description:
    //             '平政范曉萱/略英文/自彈自唱/才藝少女/目前正職為西貢Q3某藝術TATTOO店老師，從小家境優渥學習音樂，後因父親沾染賭癮以致家道中落，窮到她們家連衣服都買不起，故其終極願望是能刺滿全身的日本極道全甲刺青，這樣就能出門不用穿衣服非常節省，如果你也是NBA 塞爾提克隊主力雙探花之0號JAYSON TATUM的粉絲，也不妨試試我們家越南節省塔兔老師的龍筋功力！',
    //         technicalLevel: '👑技術總監',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 1,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️❤️🤍9/10',
    //     },
    //     {
    //         id: 1,
    //         number: 1,
    //         name: '豪爽一姐',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.01%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.01%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.01%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.01%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.01%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.01%20(4).webp',
    //         ],
    //         height: 165,
    //         weight: 51,
    //         birthYear: 1994,
    //         description:
    //             '開背王者/不知火燈-可全自動/酸痛救星，豪爽北姑，喜歡直球對決，有背就開，球來就打，據說沒有他開不了的背，想體驗一姐好爽的貴賓千萬一定要試看看。',
    //         technicalLevel: '👑首席技術總監',
    //         removal: '🌻自求多福',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 2,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️🤍🤍🤍🤍 6/10',
    //     },
    //     {
    //         id: 2,
    //         number: 2,
    //         name: '幸運女神',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.02%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.02%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.02%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.02%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.02%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.02%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.02%20(5).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.02%20(6).webp',
    //         ],
    //         height: 160,
    //         weight: 48,
    //         birthYear: 1994,
    //         description:
    //             '改裝燈-可全自動/可中英韓文/熱愛健身/熱情大方/評價:擔任本團隊首席技術總監，號稱沒有推不開的筋絡的她，上背部繡有來自清邁的性感招福圖騰，需要轉運的您不容錯過～',
    //         technicalLevel: '👑首席技術總監',
    //         removal: '🌻曾經升級，但被印度貴賓內痔掉出驚嚇，目前尚有陰影，暫不提供，希望有貴賓能夠輔導她再次走出陰霾😹',
    //         serviceMedal: '🏅已頒發',
    //         note: '技術總監首席指定費+50萬越盾起(手法完全不同，純按的貴賓請路過)',
    //         paymentNote: '',
    //         sortOrder: 3,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️❤️💛9.5/10',
    //     },
    //     {
    //         id: 3,
    //         number: 3,
    //         name: '妖熟都市',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.03%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.03%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.03%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.03%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.03%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.03%20(4).webp',
    //         ],
    //         height: 158,
    //         weight: 51,
    //         birthYear: 1992,
    //         description:
    //             '不知火燈-全自動/習慣在客人住處各個角落留下愛液氣味記號，家有女主人者建議路過，愛喝臭酸豆漿，歡迎老闆們大膽施捨。2024年第三季好評王強力競爭者。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 4,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 7,
    //         number: 7,
    //         name: '股辣勃騎',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.07%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.07%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.07%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.07%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.07%20(3).webp',
    //         ],
    //         height: 160,
    //         weight: 46,
    //         birthYear: 1980,
    //         description:
    //             '豪爽系北方御姐，前GRAB（谷辣勃)稀有越南女司機騎士，一次執行馬伕送妹上門服務途中，妹子被客人退貨，倒是身為駕駛的她被熟女控客戶看上，第一次的任務就讓客人酥麻升天，從此激發了她從事對按摩業的熱情，平時熱愛游泳上健身房的她視覺年齡不到35歲，被票選為2014熟女界多汁美味天菜，吸引不少貴賓週週回沖，歡迎大家指名騎乘駕馭。該技師具有化解現代人久坐引起的肩背僵硬的神手能力，按完立感生龍活虎之效。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 5,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 9,
    //         number: 9,
    //         name: '愛田馬眼',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.09%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.09%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.09%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.09%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.09%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.09%20(4).webp',
    //         ],
    //         height: 157,
    //         weight: 48,
    //         birthYear: 2000,
    //         description:
    //             '不明車燈/全自動/西貢小周迅/曾在日本街正規按摩店工作兩年，因多次遭到無良餓狼日本老闆藉酒騷擾憤而離職，一雙看似柔弱的水汪汪大眼惹人憐愛，按摩功力確是相當紮實不馬虎，受過日式專業訓練的她非常親切有禮，最愛舔舐香甜碩大的馬眼睛',
    //         technicalLevel: '👑體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 6,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️🤍🤍8/10',
    //     },
    //     {
    //         id: 12,
    //         number: 12,
    //         name: '西貢蒨蓉',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.12%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.12%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.12%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.12%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.12%20(3).webp',
    //         ],
    //         height: 155,
    //         weight: 45,
    //         birthYear: 1975,
    //         description:
    //             '原廠車燈-後續不明/［熟女版李蒨蓉］憑藉一對不科學的天然木瓜+麥克傑克遜月球漫步踩背+獨家可以上門服務的火罐龍筋，以超過45歲的高齡還是能在競爭激烈的西貢按摩圈擁有一席之地，該技師具有化解現代人久坐引起的肩背僵硬的神手能力，按完立感生龍活虎之效',
    //         technicalLevel: '👑技術總監',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 7,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️10/10',
    //     },
    //     {
    //         id: 14,
    //         number: 14,
    //         name: '私教禁臠',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.14%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.14%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.14%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.14%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.14%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.14%20(4).webp',
    //         ],
    //         height: 160,
    //         weight: 50,
    //         birthYear: 1999,
    //         description:
    //             '原裝-手排擋，就讀大學時曾擔任鄰居家裡情竇初開初中小帥哥的家庭教師，不慎中出擦出火花，遭天主教校評會開除，憤而投入按摩圈，方得好手藝，未來收山後不排除重返教育圈正式成為修女。',
    //         technicalLevel: '體驗級',
    //         removal: '🚧待君洗腦',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 8,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 15,
    //         number: 15,
    //         name: '櫻津古折',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.15%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.15%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.15%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.15%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.15%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.15%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.15%20(5).webp',
    //         ],
    //         height: 161,
    //         weight: 50,
    //         birthYear: 1992,
    //         description:
    //             '原廠-全自動/英文佳/事實証明了胖子都是潛力股，曾經坐斷顧客小兄弟的她，現已完全瘦身成功，而一直在線的按摩實力與扛扛之力道不因瘦下來就打折，朋友們想專心或是醉翁按摩皆相宜。',
    //         technicalLevel: '👑技術總監',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 9,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️❤️🤍9/10',
    //     },
    //     {
    //         id: 16,
    //         number: 16,
    //         name: '赤裸羔羊',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.16%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.16%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.16%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.16%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.16%20(3).webp',
    //         ],
    //         height: 160,
    //         weight: 46,
    //         birthYear: 1990,
    //         description:
    //             '原廠車燈-全自動/全服務團隊中最快速度晉升技術總監級，看似無辜保守的小綿羊，一旦被掌握開關後，如虎狼般宣洩的洪流，讓不少體驗過的貴賓週週回沖，該技師具有化解現代人久坐引起的肩背僵硬的神手能力，按完立感生龍活虎之效。貴賓如需添加古法去濕走火罐服務+50萬越盾',
    //         technicalLevel: '👑技術總監',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 10,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️🤍🤍🤍7/10',
    //     },
    //     {
    //         id: 17,
    //         number: 17,
    //         name: '大股香蘋',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.17%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.17%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.17%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.17%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.17%20(3).webp',
    //         ],
    //         height: 165,
    //         weight: 75,
    //         birthYear: 2003,
    //         description:
    //             '罕見原廠大紅心型車燈-升級服務不明自行開發/越式洗頭+泰式龍筋二刀流/南美熱巴肥臀系天菜，里約熱內盧出生，三歲父母離異後回到越南生活，17歲時曾代表越南在巴西嘉年華花車皇后競選中奪得最上鏡頭獎，外型健美內在溫柔單身中的她，渴望在服務中能遇到生命中的大谷翔平，為她奮力擊出破生涯紀錄第55號完全高潮的全壘打，超愛吃東坡肉焢肉飯的老鐵們，請把握遇到終極大魔王的好機會！(PS還是處女，連手心都還是處女，按摩讚，但如果不能升級概不負責)',
    //         technicalLevel: '體驗級(連手心都還是處女)',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 11,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️🤍🤍🤍7/10',
    //     },
    //     {
    //         id: 22,
    //         number: 22,
    //         name: '蜜桃成熟',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.22%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.22%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.22%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.22%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.22%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.22%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.22%20(5).webp',
    //         ],
    //         height: 155,
    //         weight: 50,
    //         birthYear: 2002,
    //         description:
    //             '改裝燈-全自動/毫無距離/有禮親切/銷魂髮香/評價:蜜桃般美妙又白又肉又多汁的身軀，為您解鎖更多高難度的拉伸姿勢。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 12,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 23,
    //         number: 23,
    //         name: '賣渴喬丹',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.23%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.23%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.23%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.23%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.23%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.23%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.23%20(5).webp',
    //         ],
    //         height: 159,
    //         weight: 46,
    //         birthYear: 1998,
    //         description:
    //             '巨型人造飛彈令人傻眼-全自動/北江御姐/愛笑主動/電力十足/評價:來自北方高冷地區，卻有一顆最火熱敢玩的心，隨時隨地請君入甕。',
    //         technicalLevel: '體驗級',
    //         removal: '🚧待君洗腦',
    //         serviceMedal: '自求多福',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 13,
    //         recommendRank: '❤️❤️❤️❤️❤️💛🤍🤍🤍🤍5.5/10',
    //     },
    //     {
    //         id: 24,
    //         number: 24,
    //         name: '痣造浪漫',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.24%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.24%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.24%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.24%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.24%20(3).webp',
    //         ],
    //         height: 157,
    //         weight: 47,
    //         birthYear: 1999,
    //         description:
    //             '原廠燈-全自動/嘴角有顆性感的愛吃痣，曾經幾年前曾在越南小姐比賽擊敗眾多塑膠臉勇奪冠軍，憑藉著嘴角那顆碩誘人的痣，迷倒台下無數觀眾和評委，退隱後被越南痞子拐騙成為一名家庭主婦，為了生計開始兼職龍筋按摩，老鐵們歡迎跟他一起製造浪漫。',
    //         technicalLevel: '體驗級',
    //         removal: '🚧待君洗腦',
    //         serviceMedal: '自求多福',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 14,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️🤍🤍🤍7/10',
    //     },
    //     {
    //         id: 25,
    //         number: 25,
    //         name: '伊三七仔',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.25%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.25%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.25%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.25%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.25%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.25%20(4).webp',
    //         ],
    //         height: 155,
    //         weight: 48,
    //         birthYear: 1997,
    //         description:
    //             '原廠燈-全自動/西貢按摩名店137前店花，生育毀容前神似那些年我們一起追的女主角，目前外型雖已完全崩壞，但當年137駐店的按摩實力仍然在線，不介意過度修圖照片的老鐵們歡迎嚐鮮。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 15,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️🤍🤍🤍7/10',
    //     },
    //     {
    //         id: 26,
    //         number: 26,
    //         name: '攻睪理穢',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.26%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.26%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.26%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.26%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.26%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.26%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.26%20(5).webp',
    //         ],
    //         height: 160,
    //         weight: 49,
    //         birthYear: 2006,
    //         description:
    //             '燈況不明/現役西貢某私立大學老人照護系大二學生，立志畢業後能往日本成為高齡看護婦，專門清理行動不便長者污垢及穢物，目前為了籌措昂貴的學費，本人非常自發地到校外實地累積經驗，希望憑著他優秀細心的清理技能，給予每位顧客最重要的部位最乾淨的清潔體驗，請45歲以上的中高齡男性同胞，給他一個貼身照顧你的機會。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 16,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️🤍🤍🤍7/10',
    //     },
    //     {
    //         id: 28,
    //         number: 28,
    //         name: '毒龍舌蘭',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.28%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.28%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.28%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.28%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.28%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.28%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.28%20(5).webp',
    //         ],
    //         height: 156,
    //         weight: 50,
    //         birthYear: 1990,
    //         description:
    //             '原廠-全自動/在為人母之前人稱西貢周海媚，沒想到生下雙胞胎以後水桶腰大走鐘，卻也增添幾分母愛韻味，雖然孩子的爸早已不知去向，但還是有毅力的減重成功堅強加入本團隊，並時刻充滿服務熱忱。缺乏母愛或嫌自己陽汁過多，需要被徹底毒龍鑽的同學，不容錯過與太急大濕陰陽調和的機會。(可配合戴上可愛眼鏡服務)',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 17,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 29,
    //         number: 29,
    //         name: '筋妃惜筆',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.29%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.29%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.29%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.29%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.29%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.29%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.29%20(5).webp',
    //         ],
    //         height: 158,
    //         weight: 45,
    //         birthYear: 2002,
    //         description:
    //             '原廠車燈/小隻馬控天菜，龍筋大越團隊新救世主，技術總監指定接班人之一，據說安排過的貴賓個個都想私心納入後宮為寵妃，因為她用心寵愛您大毛肉筆的功夫，比你陪伴自己長大的十姑娘，更勝十倍！',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 18,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️🤍🤍🤍7/10',
    //     },
    //     {
    //         id: 33,
    //         number: 33,
    //         name: '破壞之王',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.33%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.33%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.33%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.33%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.33%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.33%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.33%20(5).webp',
    //         ],
    //         height: 163,
    //         weight: 50,
    //         birthYear: 2003,
    //         description:
    //             '不知火燈-全自動/芽莊鍾麗緹/越戰時期其祖母慘遭美國黑人大兵硬上並射後不理。故擁有四分之一黑人血統，熱情奔放。現為某越南某專櫃輕熟女服飾百變代言人，英語貿易相關大學科系留級七年就讀中，專長是按摩以外你想得到的任何事，除了按摩中等其他的都行，但她跟公司保證一定讓客人滿意，非常歡迎各路好漢對其進行體內深層破壞直至完全升天。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 19,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 34,
    //         number: 34,
    //         name: '西貢智賢',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.34%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.34%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.34%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.34%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.34%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.34%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.34%20(5).webp',
    //         ],
    //         height: 167,
    //         weight: 48,
    //         birthYear: 2003,
    //         description:
    //             '原裝燈-全自動/英文流利/越戰時期其祖母慘遭美國黑人大兵硬上並射後不理。故擁有四分之一黑人血統，熱情奔放。現為某越南品牌少女服裝百變代言人，號稱[原裝版全智賢] 頸部以下完美，英語貿易相關大學科系就讀中，專長是按摩以外你想得到的任何事，除了按摩不行其他的都行，但她跟公司保證一定讓客人滿意。',
    //         technicalLevel: '體驗級',
    //         removal: '🚧待君洗腦',
    //         serviceMedal: '自求多福',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 20,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 35,
    //         number: 35,
    //         name: '幼齒菁仔',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.35%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.35%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.35%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.35%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.35%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.35%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.35%20(5).webp',
    //         ],
    //         height: 160,
    //         weight: 45,
    //         birthYear: 2005,
    //         description:
    //             '東京熱之西貢激鬥番外篇YouTuber 御用女主角，我們知道你找的就是她，勸君先練好馬拉松再來挑戰二連發才滿足她。',
    //         technicalLevel: '體驗級',
    //         removal: '🚧待君洗腦',
    //         serviceMedal: '自求多福',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 21,
    //         recommendRank: '❤️❤️❤️❤️❤️💛🤍🤍🤍🤍5.5/10',
    //     },
    //     {
    //         id: 36,
    //         number: 36,
    //         name: '笑容可菊',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.36%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.36%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.36%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.36%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.36%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.36%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.36%20(5).webp',
    //         ],
    //         height: 169,
    //         weight: 40,
    //         birthYear: 2002,
    //         description:
    //             '改裝燈-全自動/大叻張碧晨，據說高潮會口吐白沫+翻白眼+海豚音，挑戰吃魚喝茶生涯最腰瘦對手，有被虐M屬性的她，甘願任君多人糟蹋也始終無怨無悔～解鎖菊門成就。',
    //         technicalLevel: '體驗級',
    //         removal: '🚧待君洗腦/卻擅長反被掏肛',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 22,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️💛🤍8.5/10',
    //     },
    //     {
    //         id: 38,
    //         number: 38,
    //         name: '甲丟厚桂',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.38%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.38%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.38%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.38%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.38%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.38%20(4).webp',
    //         ],
    //         height: 162,
    //         weight: 50,
    //         birthYear: 1999,
    //         description:
    //             '原廠燈/全自動/英文佳/西貢某國際醫院護士長(請大家保密）害羞易臉紅，卻大方又敢玩，製造最完美的反差衝突感，熱愛瑜伽、皮拉提斯，歡迎解鎖不可思議的高難度POSE!據說還特別愛用她異常突出的下顎刮搔男友冠狀溝，直至完全升天。',
    //         technicalLevel: '👑技術總監',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 23,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️❤️🤍9/10',
    //     },
    //     {
    //         id: 42,
    //         number: 42,
    //         name: '德州荷官',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.42%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.42%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.42%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.42%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.42%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.42%20(4).webp',
    //         ],
    //         height: 160,
    //         weight: 50,
    //         birthYear: 1999,
    //         description:
    //             '改裝-全自動，江湖人稱濠莊李毓芬，曾任職某賭場二線荷官，卻不慎染上賭癮欠下10億巨債，被迫從事按摩，因此習得一技之長翻轉人生也未嘗不是好事一樁，她願意勇敢積極面對人生的困境，也請大家支持她的奮戰精神給予鼓勵。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 24,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️💛🤍8.5/10',
    //     },
    //     {
    //         id: 44,
    //         number: 44,
    //         name: '奪魂鋸駟',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.44%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.44%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.44%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.44%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.44%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.44%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.44%20(5).webp',
    //         ],
    //         height: 160,
    //         weight: 48,
    //         birthYear: 1998,
    //         description:
    //             '軟性車燈/大學法醫系畢業/人妖控天菜(保證100%天然女人)，雖然隱約長得有點像人妖+奪魂老砲面具合體，但不能掩蓋她對於男性全身構造的透徹了解，其拳拳到肉的服務，能夠完全觸發您最深層敏感穴位。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 25,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️💛🤍8.5/10',
    //     },
    //     {
    //         id: 47,
    //         number: 47,
    //         name: '禽爆菊脹',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.47%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.47%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.47%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.47%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.47%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.47%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.47%20(5).webp',
    //         ],
    //         height: 164,
    //         weight: 53,
    //         birthYear: 1999,
    //         description:
    //             '前中越解放軍某退役情報局長御用坐騎，每每想起這段因被上級利用職務之便恐嚇而淪為肉便器，甚至還被賞給下屬們同時輪流使用的不堪過往(爆菊三通，歡迎解鎖)，一有空時就會獨自前往古芝地道靶場拿起AK47實彈瘋狂射擊洩憤。如果下身正有一把無名火卻無處發洩的貴賓，這位曾經的軍用滅火器等級好手，歡迎您的大膽挑戰！並順便開啟人生的另一扇(大學)窄門。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級(可雙向)',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 26,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️🤍🤍🤍7/10',
    //     },
    //     {
    //         id: 50,
    //         number: 50,
    //         name: '吸力人妻',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.50%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.50%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.50%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.50%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.50%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.50%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.50%20(5).webp',
    //         ],
    //         height: 159,
    //         weight: 45,
    //         birthYear: 1994,
    //         description: '原裝燈/全自動/寒冰龍筋掌+酸爽升天拉蛋，日間出沒限定私兼菜籃族。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 27,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 51,
    //         number: 51,
    //         name: '鈴木一蘭',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.51%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.51%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.51%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.51%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.51%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.51%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.51%20(5).webp',
    //         ],
    //         height: 155,
    //         weight: 48,
    //         birthYear: 2001,
    //         description:
    //             '不明車燈/全自動/西貢日本街第五屆拉麵大胃王女子組冠軍(15.5碗)，雖然看似身軀嬌小卻蘊含巨大能量，能將所有吃下的大量食物，完全轉換成服務貴賓的動力，食量大床上需求更是大，個性溫柔配合度高，喜歡聽話乖巧型妹子的老鐵們必需安排上。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 28,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 52,
    //         number: 52,
    //         name: '一針見笑',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.52%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.52%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.52%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.52%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.52%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.52%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.52%20(5).webp',
    //         ],
    //         height: 158,
    //         weight: 50,
    //         birthYear: 2000,
    //         description:
    //             '前西貢某區域型醫院小護士，因為厭倦了急診室忙碌的生活，開始正視自己內心的欲求不滿，因此脫下白袍加入龍筋服務團隊。個人最得意的專長是幫病患注射和打針，目前最大的心願是希望能幫助廣大男性同胞重振雄風，常常幫別人注射的她，偶爾也希望能夠享受被注射的快感，希望貴賓能讓她一針見笑，感受到立竿見影的治癒快感。',
    //         technicalLevel: '體驗級',
    //         removal: '🚧未升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 29,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️💛🤍8.5/10',
    //     },
    //     {
    //         id: 54,
    //         number: 54,
    //         name: '肉便寵物',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.54%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.54%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.54%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.54%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.54%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.54%20(4).webp',
    //         ],
    //         height: 154,
    //         weight: 42,
    //         birthYear: 2003,
    //         description:
    //             '原廠-全自動/北越老家中有六個姐姐，雖號稱七仙女之家，但僅有的154公分已是全家最高五臟俱全，按摩技術不容小覷，親切認真絕不油膩的服務，極有機會奪下2023年龍筋大越新人好評王！',
    //         technicalLevel: '體驗級',
    //         removal: '🚧未升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 30,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 59,
    //         number: 59,
    //         name: '獸醫護士',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.59%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.59%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.59%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.59%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.59%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.59%20(4).webp',
    //         ],
    //         height: 152,
    //         weight: 45,
    //         birthYear: 2003,
    //         description:
    //             '原廠-全自動/神似台灣某職業球隊啦啦隊長，專長為萎靡不振的哥哥們鼓舞士氣、重振雄風，志願做個稱職的獸醫護士。',
    //         technicalLevel: '體驗級',
    //         removal: '🚧未升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 31,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️8/10',
    //     },
    //     {
    //         id: 61,
    //         number: 61,
    //         name: '酒品芝麻',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.61%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.61%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.61%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.61%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.61%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.61%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.61%20(5).webp',
    //         ],
    //         height: 159,
    //         weight: 47,
    //         birthYear: 2001,
    //         description:
    //             '原廠-全自動/正職為越南知名酒商御用品酒師，因走私數櫃洋酒被海關查獲沒收，無力償還只得兼職按摩，有人說她神韻類似九品芝麻官中的如煙-港星蔡少芬，也請您來品嚐這支後勁強烈的美酒',
    //         technicalLevel: '體驗級',
    //         removal: '🚧待君洗腦',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 32,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 63,
    //         number: 63,
    //         name: '內排機場',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.63%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.63%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.63%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.63%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.63%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.63%20(4).webp',
    //         ],
    //         height: 163,
    //         weight: 47,
    //         birthYear: 1995,
    //         description:
    //             '無車燈-全自動/貧乳系天菜，氣質出眾，是一座非常適合體內排放毒素的天然機場，歡迎各國大型航空器盡情停泊。(曾經完全無車燈，據說最近升級手感不錯之人造車燈，歡迎試揉以協助假體軟化。)',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 33,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️💛🤍🤍7.5/10',
    //     },
    //     {
    //         id: 64,
    //         number: 64,
    //         name: '北港嚮驢',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.64%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.64%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.64%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.64%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.64%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.64%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.64%20(5).webp',
    //         ],
    //         height: 172,
    //         weight: 50,
    //         birthYear: 1997,
    //         description:
    //             '原廠車燈/西貢吳佩慈/天生神力女超人/模特比例/據聞該技師生父來自台灣雲林北港鄉，為大名鼎鼎身高一米九之國術師"北港六尺四"後裔。雖為台越混血兒，但其生父在薄寮省養蝦創業失敗後，就射後不理並狠心拋棄妻女，捲股東款逃往柬埔寨方向，迄今杳無音信，雖然成長過程來不起學習中文，由母親獨自辛苦扶養長大，但仍然繼承了父親國術家族的優良基因，擁有172公分鶴立雞群身高以及天生按摩神力，重按組貴賓肯定不容錯過，最嚮往挑戰擁有驢__般神器高質量男士，歡迎對自己陽__特別有自信的老鐵們，慷慨激昂從容赴義！',
    //         technicalLevel: '👑體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 34,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️🤍🤍8/10',
    //     },
    //     {
    //         id: 65,
    //         number: 65,
    //         name: '出水福容',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.65%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.65%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.65%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.65%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.65%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.65%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.65%20(5).webp',
    //         ],
    //         height: 164,
    //         weight: 52,
    //         birthYear: 2001,
    //         description:
    //             '前西貢某知名品牌酒店前檯服務人員，客人點評最厲害的技能是3秒出水，曾經連續衛冕三次大胃王盃冠軍，曾在比賽3分鐘吞下6.5碗拉麵的她，這項記錄至今沒有挑戰者可以挑戰成功。因為參加大胃王比賽帶來的後遺症，近期的她看起來略為發福，希望能跟體力好的貴賓來場激烈馬拉松瘦身運動，熱愛健美的你快來見識她三秒出水的絕技。',
    //         technicalLevel: '👑體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 35,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️🤍🤍🤍7/10',
    //     },
    //     {
    //         id: 67,
    //         number: 67,
    //         name: '秘姿騷拷',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.67%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.67%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.67%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.67%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.67%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.67%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.67%20(5).webp',
    //         ],
    //         height: 160,
    //         weight: 50,
    //         birthYear: 2000,
    //         description:
    //             '不明車燈-全自動/前越南國際警部偵查犯罪科王牌拷問官，據說沒有他拷問不出來的犯人，擅長使用神秘姿勢對不服從的男人施以酷刑，沒有一個男人能抵抗她的秘姿誘惑，想要解鎖神秘姿勢的貴賓，快來排隊接受她的騷拷，試看看能不能扛住她的終極靈魂拷問。',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 36,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️🤍🤍8/10',
    //     },
    //     {
    //         id: 69,
    //         number: 69,
    //         name: '男言汁穎',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.69%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.69%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.69%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.69%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.69%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.69%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.69%20(5).webp',
    //         ],
    //         height: 158,
    //         weight: 48,
    //         birthYear: 2000,
    //         description:
    //             '車燈不明/西貢趙O穎/白虎微毛被動系天菜，河內某戲劇學院畢業，曾於下龍灣拍攝中國電影時擔任趙O穎替身，不慎遭船舷割傷右胸，因此留下紀念性害羞傷疤，如有老鐵們喜歡主動發起攻擊，品嚐昏死煎魚女兒國王的，切勿放過當酒肉唐僧的機會。(PS.有一點點照騙嫌疑。恕不退貨)',
    //         technicalLevel: '體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 37,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️🤍🤍🤍7/10',
    //     },
    //     {
    //         id: 77,
    //         number: 77,
    //         name: '致命突擊',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.77%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.77%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.77%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.77%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.77%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.77%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.77%20(5).webp',
    //         ],
    //         height: 158,
    //         weight: 45,
    //         birthYear: 2000,
    //         description:
    //             '原廠-全自動/，英文極佳可溝通，河內某情報特務學校畢業，曾赴金三角參與秘密行動，現職為游泳教練，已穿騷氣肚臍環，願望是再為貴賓朋友們穿上痛徹心扉之終極乳環，是位極具個人魅力的優質老師。',
    //         technicalLevel: '體驗級',
    //         removal: '🚧待君洗腦',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 38,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️🤍🤍8/10',
    //     },
    //     {
    //         id: 95,
    //         number: 95,
    //         name: '吾欠騎友',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.95%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.95%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.95%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.95%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.95%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.95%20(4).webp',
    //         ],
    //         height: 160,
    //         weight: 50,
    //         birthYear: 1996,
    //         description:
    //             '不明車燈/全自動/酷愛騎腳踏車戶外踏青，順便尋找叢林野合炮友，如果您也在尋找喜愛以天為帳以地為床的知己，這位看似淡漠實則有點淡漠的老師，歡迎您拖到路邊處理～(PS她沒得罪我，只是我江郎才盡)',
    //         technicalLevel: '👑體驗級',
    //         removal: '🌻已升級',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 39,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️🤍🤍7/10',
    //     },
    //     {
    //         id: 99,
    //         number: 99,
    //         name: '久久神宮',
    //         image: 'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/small/No.99%20(0).webp',
    //         images: [
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.99%20(0).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.99%20(1).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.99%20(2).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.99%20(3).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.99%20(4).webp',
    //             'https://storage.googleapis.com/public-access-bucket-vnhappy7-dev/therapist/No.99%20(5).webp',
    //         ],
    //         height: 163,
    //         weight: 45,
    //         birthYear: 2002,
    //         description:
    //             '真實袖珍車燈/特技:升天電光毒龍鑽/身材比例好/御姐范/略英文/從西貢最知名風俗場-[龍宮]N顧茅廬費心勸降挖角而來的前三名紅牌技師，對於最近日益拿翹(滿天漲價)的龍宮集團採取抵制措施的老鐵們，現在只要一半的價格，就可以享有媲美莞式全部的服務，從此不用再舟車勞頓跑龍宮在家爽，自認重口味，不夠刺激沒反應的植物屌，務必迎戰後完全回血恢復久久神功！',
    //         technicalLevel: '👑除了按摩之外的超技術總監',
    //         removal: '🌻已升級(用口掏)',
    //         serviceMedal: '🏅已頒發',
    //         note: '',
    //         paymentNote: '',
    //         sortOrder: 40,
    //         recommendRank: '❤️❤️❤️❤️❤️❤️❤️❤️❤️🤍9/10',
    //     },
    // ])
    const teachers = ref<Array<Teacher>>([])
    const getEscortPlanById = (planId: number) => {
        console.log('getEscortPlanById', planId)
        return escortPlans.value.find((plan) => plan.id == planId)
    }
    const getAllGuides = () => {
        const params = {
            offset: 0,
            limit: 1000,
        }
        return api.axiosInstance.get('/plan/escort/guide', { params }).then((response) => {
            guides.value = response.data.data
        })
    }
    const getAllTherapists = () => {
        const params = {
            offset: 0,
            limit: 1000,
        }
        return api.getTherapists(params).then((response) => {
            therapists.value = response.data.data
        })
    }
    const getAllTeachers = () => {
        const params = {
            offset: 0,
            limit: 10,
        }
        return api.axiosInstance.get('/plan/tutor/teacher', { params }).then((response) => {
            teachers.value = response.data.data
        })
    }
    const doAfterLogin = () => {
        return Promise.all([getAllTherapists(), getAllTeachers()])
    }
    return {
        headerConfig,
        escortPlans,
        guides,
        attractions,
        therapists,
        teachers,
        getEscortPlanById,
        setHeaderConfig,
        getAllTherapists,
        doAfterLogin,
        getAllGuides,
        getAllTeachers,
    }
})
